import { css } from '@emotion/css';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { ArrowIosRightOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { DeprecatedIconButton } from '@lyearn/ui';
import { TableComponents } from '@/components/Table/types';
import { svgSizeStyles } from '@/utils/styles';

const expandIconStyles = css`
  width: 2.4rem;
  height: 2.4rem;
  ${svgSizeStyles(1.6)}
`;

export const getTableChartComponents = ({
  enableExpandIconPropagation = true,
  className,
}: {
  enableExpandIconPropagation?: boolean;
  className?: string;
}): TableComponents => ({
  ExpandIcon: ({ expandable, expanded, onExpand }) => {
    if (!expandable) {
      return null;
    }

    return (
      <DeprecatedIconButton
        appearance="secondary"
        className={cn(expandIconStyles, { 'rotate-90 transform': expanded }, className)}
        shape="square"
        variant="ghost"
        onClick={(event) => {
          if (enableExpandIconPropagation) {
            stopEventPropagation(event);
          }
          onExpand(!expanded);
        }}>
        <ArrowIosRightOutline />
      </DeprecatedIconButton>
    );
  },
});
